/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExerciseSubmissionService
 */

export const startRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExerciseSubmissionService',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'j5PaHndzC97h703xnPV_-Gam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const completeExerciseEventsRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExerciseSubmissionService',
  rpcName: 'completeExerciseEvents',
  auth: 'app',
  fingerprint: 'CWq2NAJVIfjh703xnPV_-Gam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExerciseSubmissionService',
  rpcName: 'submit',
  auth: 'app',
  fingerprint: 'b1NRUNoHCCzOuBvFDwBEImam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};